export default "__VITE_ASSET__yd3QldzK__"